import { render } from "./EmployeePayrunPeriodModal.vue?vue&type=template&id=49a9d6e8"
import script from "./EmployeePayrunPeriodModal.vue?vue&type=script&lang=js"
export * from "./EmployeePayrunPeriodModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__